import AuthRoute from './AuthRoute';
import CreatePassword from './CreatePassword';
import React from 'react';
import { withTranslation } from 'react-i18next';

class ResetPassword extends AuthRoute {
    renderBody = () => {
        return (
            <>
                <CreatePassword />
            </>
        );
    };
}

export default withTranslation()(ResetPassword);
